module.exports = __webpack_public_path__ + "img/main-gallery1.f24416ea.webp";